import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

// modules
import application, { ApplicationState } from "./modules/ApplicationModule";

import alert from "./modules/AlertModule";
import * as alertTypes from "./modules/AlertModule/types";

import configuration from "./modules/ConfigurationModule";

import devices from "./modules/DevicesModule";

// Authentication
import authMod from "./modules/AuthenticationModule";
import { AuthenticationState } from "./modules/AuthenticationModule/state";

import license from "./modules/LicenseModule";
import { LicenseState } from "./modules/LicenseModule/state";

import notifications from "./modules/NotificationsModule";
import options from "./modules/OptionsModule";
import polling from "./modules/PollingModule";

// Dashboard
import dashboard from "./modules/DashboardModule/index";
import { DashboardState } from "./modules/DashboardModule/state";

import installationWorkload from "./modules/InstallationsWorkloadModule";
import { InstallationsWorkloadState } from "./modules/InstallationsWorkloadModule/state";

import updatePackages from "./modules/UpdatePackagesModule";
import { UpdatePackagesState } from "./modules/UpdatePackagesModule/state";

// Fitness and Statistics
import fitnessStatistics from "./modules/FitnessStatisticsModule";
import { FitnessStatisticsState } from "./modules/FitnessStatisticsModule/state";

//LogAnalysis
import { DevicesState } from "./modules/DevicesModule/state";
import logAnalysis from "./modules/LogAnalysisModule";
import { LogAnalysisState } from "./modules/LogAnalysisModule/state";
import { NotificationState } from "./modules/NotificationsModule/state";
import { OptionState } from "./modules/OptionsModule/state";

Vue.use(Vuex);

export interface RootState {
    authMod: AuthenticationState;
    application: ApplicationState;
    alert: alertTypes.AlertState;
    dashboard: DashboardState;
    license: LicenseState;
    installationWorkload: InstallationsWorkloadState;
    updatePackages: UpdatePackagesState;
    fitnessStatistics: FitnessStatisticsState;
    logAnalysis: LogAnalysisState;
    notifications: NotificationState;
    options: OptionState;
    devices: DevicesState;
}

export default new Vuex.Store<RootState>({
    modules: {
        authMod,
        application,
        alert,
        configuration,
        dashboard,
        license,
        options,
        devices,
        notifications,
        polling,
        installationWorkload,
        updatePackages,
        fitnessStatistics,
        logAnalysis,
    },
} as StoreOptions<RootState>);
